export {
  formatNumberToIntegerTruncatedString,
  capitalize,
  stringToNumber,
  titelize,
  formatValue,
} from './format';
